import { routes } from 'config';
import { useMatch } from 'react-router-dom';
import { PageContext } from './usePageContext.types';

export const usePageContext = (): PageContext => {
  const isCampaignPage = useMatch(`${routes.search({ campaignId: ':id' })}`);
  const isSharePage = useMatch(`${routes.sharedCandidatePage()}`);
  const isCandidatePage = useMatch(`${routes.candidatePage()}`);
  const isCentralInboxPage = useMatch(`${routes.centralInbox}`);
  const isHomePage = useMatch(`${routes.home}`);
  const isRobinJrHomePage = useMatch(`${routes.robinJr.home}`);
  const isRatedCandidatesPage = useMatch(`${routes.ratedCandidates}`);

  if (isCampaignPage) return PageContext.Campaign;
  if (isSharePage) return PageContext.Shared;
  if (isCandidatePage) return PageContext.Candidate;
  if (isHomePage) return PageContext.Home;
  if (isRobinJrHomePage) return PageContext.RobinJrHome;
  if (isRatedCandidatesPage) return PageContext.RatedCandidates;
  if (isCentralInboxPage) return PageContext.CentralInbox;

  return PageContext.Other;
};
